/**
 * ExtendDeveloperTrialCommand - Extend trial for a developer plan tenant
 * Follows MediatR pattern (Command + Handler in same file)
 */

import type { ICommand, ICommandHandler, IHttpClient, BaseApiResponse } from '@/application/core';
import type { ExtendTrialResult } from '@/application/queries/developerPlan/developer-plan.types';
import { toCamelCase } from '@/utils/caseTransform';

// ============================================================================
// Command (Request)
// ============================================================================

export class ExtendDeveloperTrialFECommand implements ICommand<ExtendTrialResult> {
  readonly type = 'ExtendDeveloperTrialFECommand' as const;

  constructor(
    public readonly networkId: number,
    public readonly newTrialEndDate: string
  ) {}
}

// ============================================================================
// Handler
// ============================================================================

export class ExtendDeveloperTrialFECommandHandler
  implements ICommandHandler<ExtendDeveloperTrialFECommand, ExtendTrialResult>
{
  constructor(private readonly httpClient: IHttpClient) {}

  async handle(command: ExtendDeveloperTrialFECommand): Promise<ExtendTrialResult> {
    try {
      const response = await this.httpClient.put<BaseApiResponse<any>>(
        `/api/v1/developer-plan/${command.networkId}/extend-trial`,
        { new_trial_end_date: command.newTrialEndDate }
      );

      if (!response.succeeded) {
        throw new Error(response.message || 'Failed to extend trial');
      }

      return toCamelCase(response.data) as ExtendTrialResult;
    } catch (error: any) {
      if (error.response?.status === 403 || error.status === 403) {
        throw new Error('Forbidden - insufficient permissions');
      }
      throw error;
    }
  }
}
